export default "/_next/static/images/f1d54a12a1a464b117b49e7d0394d707.jpg";